import React from 'react'
import { useTranslation } from 'react-i18next'
import { ConfigProvider, Row, Col } from 'antd'
import { getMaterialChangeLogForOrderPart } from '$api/evoAPIs'
import { useQuery } from '@tanstack/react-query'

const MaterialChangeLogView = ({ orderPart }) => {
  const { t } = useTranslation()

  const { data: changeLogData } = useQuery(
    ['material-change-log', orderPart.id],
    () => getMaterialChangeLogForOrderPart({ order_part_id: orderPart.id }),
    {
      enabled: !!orderPart.id,
    },
  )

  return (
    <ConfigProvider
      theme={{
        token: {
          colorSplit: '#fff',
        },
      }}
    >
      <Row style={{ marginBottom: '30px' }} gutter={50}>
        <Col span={4}>
          <div>
            <h4>{t('received_requests.original_request_material')}</h4>
            <p>
              <b>{changeLogData?.old_operator_additive_material || 'N/A'}</b>
            </p>
          </div>
        </Col>
        <Col span={4}>
          <div>
            <h4>{t('received_requests.operator_selected_material')}</h4>
            <p>
              <b>{changeLogData?.new_operator_additive_material || 'N/A'}</b>
            </p>
          </div>
        </Col>
      </Row>
    </ConfigProvider>
  )
}

export default MaterialChangeLogView
